export default "__VITE_ASSET__0hMvWGay__"